import Label from '../Label/Label'

const Input = ({
    iconVisibility = true,
    field,
    labelText,
    form,
    className,
    ...props
}) => {
    const getFieldClasses = (touched, errors, value) => {
        const classes = ['form-control'];

        if (touched && errors) {
            iconVisibility
                ? classes.push('is-invalid')
                : classes.push('border-danger');
            } else if (touched && !errors && value && String(value).trim()) {
            // Show green only if value is non-empty
            iconVisibility
                ? classes.push('is-valid')
                : classes.push('border-success');
        }

        return classes.join(' ');
    };

    const touched = form.touched?.[field.name];
    const error = form.errors?.[field.name];
    const value = field.value;

    return (
        <>
            <Label labelText={labelText} />
            <input
                className={`d-block mt-1 ${className} ${getFieldClasses(
                    touched,
                    error,
                    value
                )}`}
                {...field}
                {...props}
            />
        </>
    );
};

export default Input
